import { render, staticRenderFns } from "./selectprice.vue?vue&type=template&id=695f614a&scoped=true&"
import script from "./selectprice.vue?vue&type=script&lang=js&"
export * from "./selectprice.vue?vue&type=script&lang=js&"
import style0 from "./selectprice.vue?vue&type=style&index=0&id=695f614a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695f614a",
  null
  
)

export default component.exports